import { ThemeProvider } from '@react-navigation/native';
import type { PropsWithChildren } from 'react';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { PaperProvider } from 'react-native-paper';
import { PaperTheme, SunriseTheme } from '../constants/Theme';

export function ThemeAndPaperProvider({ children }: PropsWithChildren) {
  return (
    <ThemeProvider value={SunriseTheme}>
      <View style={styles.paperContainer}>
        <PaperProvider theme={PaperTheme}>{children}</PaperProvider>
      </View>
    </ThemeProvider>
  );
}

// https://github.com/callstack/react-native-paper/issues/3678#issuecomment-2171030642
const styles = StyleSheet.create({
  paperContainer: {
    flex: 1,
    overflow: 'hidden',
  },
});
